import { AiStoryModel, StoryFramesModel } from 'interface/models';
import { useStoryFramesQuery } from 'queries/ai-threshold';
import './style.scss';
import TimelineEditor from './engine-basic';
import { Skeleton } from 'antd';

export const TimelinePlanV2 = (props: { qStory: any; storyId: number }) => {
  const qFrames = useStoryFramesQuery(props.storyId);

  const frames: StoryFramesModel[] = qFrames.data?.FrameController_getStoryFrames || [];
  const story: AiStoryModel = props.qStory.data?.StoryController_getStoryById;

  if (qFrames.loading || props.qStory.loading) {
    return <Skeleton active />;
  }

  if (!frames || frames.length === 0) {
    return <div className="TimelinePlanV2">No frames available</div>;
  }

  return (
    <>
      <TimelineEditor frames={frames} story={story} />
    </>
  );
};
